import React from 'react';

interface Props {
  title: string;
  label?: string;
  children: React.ReactNode;
  className?: string;
}

const DashboardCard: React.FC<Props> = ({ title, label, children, className }) => {
  return (
    <div className={`dashboard-card ${className || ''}`}>
      <h3 className="dashboard-card-title">{title}</h3>
      {label && <h3 className="dashboard-card-label">{label}</h3>}
      <div className="dashboard-card-content">
        {children}
      </div>
    </div>
  );
};

export default DashboardCard;